import requestErrorMessage from './requestErrorMessage';

const initialState = {
  fileToken: null,
  requestId: null,
  isLoading: false,
  errorMessage: null,
};

export default (state, action) => {
  const currentState = state || initialState;

  switch (action.type) {
    case 'USER_LOGGED_OUT':
      return initialState;
    case 'SHOW_MODAL':
    case 'HIDE_MODAL':
      return {
        ...initialState,
        requestId: currentState.requestId,
      };
    case 'BEGIN_UPDATE_EMAIL_ATTACHMENT_PATIENT': {
      if (currentState.requestId !== null
        && currentState.requestId >= action.meta.requestId) return currentState;

      return {
        fileToken: action.meta.fileToken,
        requestId: action.meta.requestId,
        isLoading: true,
        errorMessage: null,
      };
    }
    case 'FAILED_UPDATE_EMAIL_ATTACHMENT_PATIENT':
      if (currentState.fileToken !== action.meta.fileToken
        || currentState.requestId !== action.meta.requestId) return currentState;
      return {
        ...currentState,
        isLoading: false,
        errorMessage: requestErrorMessage(
          action.payload?.response?.status,
          'Unable to update record. Please try again.',
        ),
      };
    case 'FINISHED_UPDATE_EMAIL_ATTACHMENT_PATIENT':
      if (currentState.fileToken !== action.meta.fileToken
        || currentState.requestId !== action.meta.requestId) return currentState;
      return {
        ...currentState,
        isLoading: false,
        errorMessage: null,
      };
    default:
      return currentState;
  }
};
